import React, {
  ChangeEvent,
  FC,
  memo,
  useCallback,
  useEffect,
  useState,
} from "react";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { ExpectedSearchValues } from "types/ExpectedForms/Search";
import Input from "../../../../../components/Input/Input";
import { TooltipContent } from "../Search.styles";
import SearchFilter from "../SearchFilter";

const FilterComment: FC<FormikProps<ExpectedSearchValues>> = ({
  initialValues,
  setFieldValue,
  values,
  handleSubmit,
}) => {
  const { t } = useTranslation("common");
  const value = values.comment;

  const [innerValue, setInnerValue] = useState(value);

  const initialValue = initialValues.comment;
  const isCommentChanged = !value;
  const commentTitle = isCommentChanged ? t("parcels.search.comment") : value;

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  const dropInnerValue = useCallback(() => setInnerValue(value), [value]);

  const applyInnerValue = useCallback(
    () => setFieldValue("comment", innerValue),
    [innerValue, setFieldValue],
  );

  const handleInnerChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target?.value) setInnerValue(event.target.value);
    },
    [],
  );

  const setDefault = useCallback(() => {
    setFieldValue("comment", initialValue);
    dropInnerValue();
  }, [dropInnerValue, initialValue, setFieldValue]);

  return (
    <SearchFilter
      applyInnerValue={applyInnerValue}
      dropInnerValue={dropInnerValue}
      handleSubmit={handleSubmit}
      setDefault={setDefault}
      title={<TitleWrapper>{commentTitle}</TitleWrapper>}
      innerTitle={t("parcels.search.selectComment")}
      isActive={!isCommentChanged}
    >
      <TooltipContent>
        <Input
          value={innerValue}
          onChange={handleInnerChange}
          placeholder={`${t("parcels.search.comment")}:`}
        />
      </TooltipContent>
    </SearchFilter>
  );
};

export default memo(FilterComment);

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
